import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { httpClient } from '../../../../../core/infra/http/apolo-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { ResendCode } from './resend-code';

export const resendCodeService: ServiceCommand<ResendCode.Response> =
  new ResendCode(httpClient, AUTH_API_ROUTES.RESEND_VALIDATE_CODE);

export type { ResendCode };
